const BottomActionBar = ({
  children,
  className,
  rootClassName,
  compactBottom = false,
}: {
  children: React.ReactNode;
  /** Extra classes for the inner content wrapper (e.g. grid layout) */
  className?: string;
  /** Extra classes for the root nav element */
  rootClassName?: string;
  /** Use a small bottom cushion while preserving the OS safe area. */
  compactBottom?: boolean;
}) => (
  // The bar is always flush to the bottom of the viewport, and the cushion
  // under the buttons is padding rather than an offset. Sitting it 20px up
  // left a strip below the fade where page content scrolled past in plain
  // sight, which read as a floating bar with a bug under it.
  <nav
    data-testid="bottom-action-bar"
    style={{
      paddingBottom: compactBottom
        ? "calc(env(safe-area-inset-bottom, 0px) + 2rem)"
        : "calc(env(safe-area-inset-bottom, 0px) + 3.25rem)",
    }}
    className={`fixed bottom-0 left-0 right-0 px-5 z-20 pointer-events-none ${compactBottom ? "pt-8" : "pt-16"} ${rootClassName ?? ""}`}
  >
    {/* Gradient fade — to the canvas base, so content dissolves into the page
        instead of hitting a band of a different color. It reaches the very
        bottom edge, so nothing shows underneath the controls. */}
    <div
      data-testid="bottom-action-scrim"
      className="absolute inset-0 bg-gradient-to-t from-[var(--bg-primary)] via-[var(--bg-primary)] via-40% to-transparent backdrop-blur-sm pointer-events-none"
    />

    <div className={`relative pointer-events-auto ${className ?? ""}`}>
      {children}
    </div>
  </nav>
);

export default BottomActionBar;
